import { BaseComment } from '../base/base-comment';
import { Mentionable } from '../base/mentionable';

export class AnnuityPensionAccountNote extends BaseComment {
  public paymentInstructionId!: string;
  public authorName!: string;
  public note!: string;

  override onDeserialize(): void {
    super.onDeserialize();
    this.comment = this.note;
    const [firstName, ...lastNames] = (this.authorName ?? '').split(' ');
    this.author = window.injector.Deserialize.instanceOf(Mentionable, {
      id: this.authorId,
      firstName,
      lastName: lastNames.join(' ')
    });
  }
}
